<template>
  <div>

    <div v-if="isMobile" class="d-flex align-items-center px-3 py-2 bg-light shadow-sm sticky-top">
      <b-button variant="link" class="p-0 mr-2" @click="drawerOpen = true">
        <b-icon-list></b-icon-list>
      </b-button>
      <span class="font-weight-bold">{{ activeTabTitle }}</span>
    </div>

    <b-sidebar
      id="controlpanel-drawer"
      title="Control Panel Menu"
      bg-variant="light"
      text-variant="dark"
      shadow
      backdrop
      placement="left"
      :visible="drawerOpen"
      @hidden="drawerOpen = false"
    >
      <hr/>
      <ul class="list-unstyled m-0">
        <li v-for="(tab, index) in tabs" :key="index" class="mb-2">
          <b-button
            block
            squared
            :variant="activeTabIndex === index ? null : 'link'"
            class="text-left"
            @click="selectTab(index)"
          >
            <b-icon :icon="tab.icon" class="mr-2"></b-icon>
            {{ tab.title }}
          </b-button>
        </li>
      </ul>
    </b-sidebar>

    <div v-if="!isMobile">
      <b-tabs card lazy v-model="activeTabIndex">
        <b-tab
          v-for="(tab, index) in tabs"
          :key="index"
          :title="tab.title"
        >
          <keep-alive>
            <component :is="tab.component"></component>
          </keep-alive>
        </b-tab>
      </b-tabs>
    </div>

    <div v-if="isMobile" class="mt-2">
      <keep-alive>
        <component v-if="activeTabComponent" :is="activeTabComponent"></component>
      </keep-alive>
    </div>

  </div>
</template>

<script>
import {
  BIconList,
  BIconBox,
  BIconFolder,
  BIconBuilding,
  BIconBadgeTm,
  BIconFileText
} from "bootstrap-vue";

import ListVendors from "@/components/ControlPanel/ListVendors";
import ListCategories from "@/components/ControlPanel/ListCategories";
import ListFinanceCompanies from "@/components/ControlPanel/ListFinanceCompanies";
import TaxExempt from "@/components/ControlPanel/TaxExempt";
import Policies from "@/components/ControlPanel/Policies";

export default {
  name: "ControlPanelMain",

  components: {
    ListVendors,
    ListCategories,
    ListFinanceCompanies,
    TaxExempt,
    Policies,

    BIconList,
    BIconBox,
    BIconFolder,
    BIconBuilding,
    BIconBadgeTm,
    BIconFileText
  },

  data() {
    return {
      drawerOpen: false,
      activeTabIndex: 0,
      isMobile: false,

      packet: { userDetails: {} },

      tabs: [
        {
          title: "VENDORS",
          icon: "box",
          component: "ListVendors"
        },
        {
          title: "CATEGORIES",
          icon: "folder",
          component: "ListCategories"
        },
        {
          title: "FINANCE COMPANIES",
          icon: "building",
          component: "ListFinanceCompanies"
        },
        {
          title: "TAX EXEMPT",
          icon: "badge-tm",
          component: "TaxExempt"
        },
        {
          title: "POLICIES",
          icon: "file-text",
          component: "Policies"
        }
      ]
    };
  },

  computed: {
    activeTabTitle() {
      const tab = this.tabs[this.activeTabIndex];
      return tab ? tab.title : "Menu";
    },
    activeTabComponent() {
      const tab = this.tabs[this.activeTabIndex];
      return tab ? tab.component : null;
    }
  },

  methods: {
    selectTab(index) {
      this.activeTabIndex = index;
      this.drawerOpen = false;
    },
    handleResize() {
      this.isMobile = window.innerWidth < 768;
    },
    initializeUser() {
      try {
        this.packet = JSON.parse(localStorage.packet || "{}");
        this.packet.userDetails = JSON.parse(localStorage.userDetails || "{}");

        // Admin-only protection
        if (this.packet.userDetails.userrole !== "admin") {
          localStorage.clear();
          this.$router.push("/");
        }
      } catch (err) {
        console.error("User data invalid:", err);
      }
    }
  },

  created() {
    this.initializeUser();
  },

  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  }
};
</script>

<style scoped>
@media (max-width: 767px) {
  .b-tabs {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ControlPanel/ControlPanelMain.vue